import { render, staticRenderFns } from "./contactsManager.vue?vue&type=template&id=d7fddf9e&lang=pug"
import script from "./contactsManager.vue?vue&type=script&lang=js"
export * from "./contactsManager.vue?vue&type=script&lang=js"
import style0 from "./contactsManager.vue?vue&type=style&index=0&id=d7fddf9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports